import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { DynamicModule } from 'ng-dynamic-component';

import { RichTextComponent } from '@valk-nx/storyblok/components/richtext/src/lib/rich-text';
import { TileGroupSectionComponent } from '@valk-nx/storyblok/components/tile-group-section/src/lib/tile-group-section';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { PageSettingsStore } from '@valk-nx/storyblok-store/src/lib/store/page-settings/page-settings.store';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

const Components = {
	richText: RichTextComponent,
	tileGroupSection: TileGroupSectionComponent,
};

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	selector: 'sb-guest-app-page',
	templateUrl: './guest-app-page.component.html',
	imports: [DynamicModule],
})
export class GuestAppPageComponent extends StoryblokRootDirective {
	components: typeof Components = Components;
	readonly pageSettingsStore = inject(PageSettingsStore);

	content = input.required<ISbStoryBlok[]>();

	constructor() {
		super();

		this.pageSettingsStore.updateState({
			hideMenu: true,
			hideFooter: true,
		});
	}
}
